import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const SekineJibika: React.FC = () => (
  <Box sx={{ maxWidth: 680, mx: 'auto', p: { xs: 3, sm: 5 }, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', borderRadius: "24px" }}>
    <Typography color="primary" variant="body2" sx={{ fontWeight: 700, mb: 2 }}>せきね耳鼻咽喉科</Typography>
    <Typography component="h1" variant="h4" sx={{ mb: 2 }}>受診について</Typography>
    <Typography color="text.secondary" sx={{ mb: 4 }}>診察券の有無に合わせて、お進みください。</Typography>
    <Box sx={{ display: 'grid', gap: 2 }}>
      <Button component={Link} to="/reservation/sekine-jibika/exist" variant="contained" size="large" sx={{ py: 2 }}>
        診察券番号ありの方
      </Button>
      <Button component={Link} to="/reservation/sekine-jibika/new" variant="outlined" size="large" sx={{ py: 2 }}>
        初めて受診の方
      </Button>
    </Box>
    <Box sx={{ mt: 2, textAlign: 'center' }}>
      <Button component={Link} to="/reservation/new" size="small" sx={{ px: 1, minHeight: 36, fontSize: '12px', color: 'text.secondary', fontWeight: 400 }}>他の医院を選ぶ</Button>
    </Box>
  </Box>
);

export default SekineJibika;
